import { render, staticRenderFns } from "./RequestReturnPackagePopup.vue?vue&type=template&id=2d6360bf"
import script from "./RequestReturnPackagePopup.vue?vue&type=script&lang=js"
export * from "./RequestReturnPackagePopup.vue?vue&type=script&lang=js"
import style0 from "./RequestReturnPackagePopup.vue?vue&type=style&index=0&id=2d6360bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports